import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { BuyDisableAdsProps } from './BuyDisableAds';

export const openDisableAdsScreen = ({ ...data }: BuyDisableAdsProps) =>
    openPopupHelper({
        popupName: popupNames.BUY_DISABLE_ADS,
        data,
    });
